module.exports = __webpack_public_path__ + "static/pm_1.dbccac28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/playmemories/assets/2x/pm_1.jpg
// module id = 391
// module chunks = 22753136400390